/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Text_To_Audio_SectionInputs */

const en_mobile_text_to_audio_section = /** @type {(inputs: Mobile_Text_To_Audio_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Audio`)
};

const es_mobile_text_to_audio_section = /** @type {(inputs: Mobile_Text_To_Audio_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a audio`)
};

/**
* | output |
* | --- |
* | "Text to Audio" |
*
* @param {Mobile_Text_To_Audio_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_text_to_audio_section = /** @type {((inputs?: Mobile_Text_To_Audio_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Text_To_Audio_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_text_to_audio_section(inputs)
	return en_mobile_text_to_audio_section(inputs)
});